import { create } from 'zustand';
import type { NormalizedApiError } from '@/services/types';

interface AccessBlockedState {
	/** The refusal that blocked the CMS session, or `null` when not blocked. */
	error: NormalizedApiError | null;
	block: (error: NormalizedApiError) => void;
	reset: () => void;
}

/**
 * Set when the tenant's CMS IP allowlist refuses a request of the signed-in
 * session (403 IP_NOT_ALLOWED). The session stays valid — the user is on a
 * network the workspace does not allow — so it is kept, and the CMS shows the
 * access-denied page instead of the app until the user retries or signs out.
 * Not persisted: a reload simply tries again.
 */
export const useAccessBlockedStore = create<AccessBlockedState>()((set) => ({
	error: null,
	block: (error) => set({ error }),
	reset: () => set({ error: null }),
}));
